import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { StepHeader } from '../StepHeader/StepHeader'
import { StepperComponent } from '../../Components/StepperComponent/StepperComponent'
import { useNavigate, useLocation } from 'react-router-dom'
import { useLocalStorage } from '../../Hooks/useLocalStorage'
import { useEffect, useState } from 'react'
import config from '../../config'
import './Step5.scss'

export const Step5 = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [loading, setLoading] = useState(false)
  const projectsFromMigrationProfile = state.migrationProfile.projects[0].data
  const taskFilter = state.migrationProfile.filters.taskFilter
  const issueFilter = state.migrationProfile.filters.issueFilter
  const documentsFilter = state.migrationProfile.filters.documentsFilter
  const projectsQueryString = state.migrationProfile.fields.projects
  const projectsFolderId = state.projectsFolderId
  const tasksQueryString = state.migrationProfile.fields.tasks
  const tasksFolderId = state.tasksFolderId
  const tasksSelected = state.selectedTasks
  const issuesSelected = state.selectedIssues
  const documentsSelected = state.selectedDocuments
  const issuesQueryString = state.migrationProfile.fields.issues
  const issuesFolderId = state.issuesFolderId
  const documentsQueryString = state.migrationProfile.fields.documents
  const documentsFolderId = state.documentsFolderId
  const selectedUpdates = state.selectedUpdates
  const selectedWorkspace = useLocalStorage('selectedWorkspace')
  const executionProfile = prepareExecutionProfile(projectsFromMigrationProfile)
  const projectEssentialsMigration = state.projectEssentialsMigration

  return (
    <Container>
      <Row>
        <StepHeader />
      </Row>
      <Row>
        <Col>
          <StepperComponent currentStep={5} />
        </Col>
      </Row>
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={10}>
          <div
            className={'mb-3'}
          >{`Projects to migrate: ${projectsFromMigrationProfile?.length}`}</div>
          <div className={'pj-picker'}>
            {projectsFromMigrationProfile?.map((projects) => (
              <ul id={projects.ID} key={projects.ID}>
                {projects.name}
              </ul>
            ))}
          </div>
        </Col>
      </Row>
      <Row className={'mt-5'}>
        <Col xs={11} className={'d-flex justify-content-end'}>
          <Button className={'me-5'} onClick={() => navigate('/step4')}>
            Back
          </Button>
          <Button
            disabled={loading}
            onClick={async () => {
              setLoading(true)
              const reponse = await fetch(`${config.BACKEND_URL}/migrate/execute`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'ngrok-skip-browser-warning': '69420',
                },
                credentials: 'include',
                // U HEADERU IDE ACCESS TOKEN OD USERA, TRENUTNO HARDCODANO NA BACKEDNU
                body: JSON.stringify({
                  migrationObject: executionProfile,
                  workspaceId: selectedWorkspace[0].id,
                  projectsQueryString: projectsQueryString,
                  tasksQueryString: tasksQueryString,
                  tasksChecked: tasksSelected,
                  issuesQueryString: issuesQueryString,
                  issuesChecked: issuesSelected,
                  documentsQueryString: documentsQueryString,
                  documentsChecked: documentsSelected,
                  projectsFolderId: projectsFolderId,
                  tasksFolderId: tasksFolderId,
                  issuesFolderId: issuesFolderId,
                  documentsFolderId: documentsFolderId,
                  fields: projectsQueryString,
                  folderId: projectsFolderId,
                  taskFilter: taskFilter,
                  issueFilter: issueFilter,
                  documentsFilter: documentsFilter,
                  selectedUpdates: selectedUpdates,
                  isCustomMigration: !projectEssentialsMigration,
                }),
              })
              if (!reponse.ok) {
                console.error('Something happend', reponse.status)
                const errorData = await reponse.json()
                setLoading(false)
                console.error(errorData)
              } else {
                setLoading(false)
                const data = await reponse.json()
                navigate('/step6')
              }
            }}
          >
            Execute
          </Button>
        </Col>
      </Row>
    </Container>
  )
}

const prepareExecutionProfile = (projects) => {
  let executionProfile = []
  for (let i = 0; i < projects?.length; i++) {
    let data = {
      project: projects[i],
      tasks: [],
      issues: [],
    }
    executionProfile.push(data)
  }
  return executionProfile
}
